import SanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = SanityClient({
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
    dataset: 'production',
    apiversion: "2022-06-01",
    useCdn: true,
    // token: process.env.REACT_APP_SANITY_TOKEN,
    perspective: 'published',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source)